// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─────────────────────────────────────────────────────────────
   Troly · /precios — full-screen pricing slide
   Tokens-only (Troly · Onyx Club). Fully theme-aware via
   --troly-* variables. No hardcoded hex, no position:fixed.
   ───────────────────────────────────────────────────────────── */

.pricing {
  position: relative;
  min-height: 100vh;
  min-height: 100svh; /* honors mobile browser chrome / PWA standalone */
  background: var(--troly-bg);
  color: var(--troly-fg);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: clamp(72px, 12vh, 120px) 20px clamp(40px, 8vh, 80px);
  font-family: var(--troly-font-body);
  overflow-x: hidden;
}

/* ── Header ──────────────────────────────────────────────────── */
.pricing__head {
  text-align: center;
  max-width: 640px;
  margin-bottom: clamp(36px, 6vh, 64px);
}

.pricing__eyebrow {
  display: inline-block;
  font-family: var(--troly-font-mono);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--troly-accent);
  margin-bottom: 14px;
}

.pricing__title {
  font-family: var(--troly-font-display);
  font-weight: 500;
  font-size: clamp(2.2rem, 7vw, 3.4rem);
  line-height: 1.05;
  letter-spacing: -0.01em;
  color: var(--troly-fg);
  margin-bottom: 14px;
}

.pricing__subtitle {
  font-size: clamp(0.95rem, 3.5vw, 1.1rem);
  line-height: 1.5;
  color: var(--troly-fg-muted);
}

/* ── Grid ────────────────────────────────────────────────────── */
.pricing__grid {
  width: 100%;
  max-width: 1100px;
  display: grid;
  grid-template-columns: 1fr; /* mobile portrait: single column */
  gap: 20px;
  align-items: stretch;
}

@media (min-width: 900px) {
  .pricing__grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    align-items: center; /* lets the featured card stand a touch taller */
  }
}

/* ── Card ────────────────────────────────────────────────────── */
.pricing-card {
  position: relative;
  display: flex;
  flex-direction: column;
  background: var(--troly-bg-elevated);
  border: 1px solid var(--troly-border);
  border-radius: var(--troly-radius-lg);
  padding: 32px 26px;
  /* entrance state — revealed via .is-visible (IntersectionObserver) */
  opacity: 0;
  transform: translateY(16px);
  transition: opacity 0.3s ease, transform 0.3s ease, border-color 0.18s;
}

.pricing-card.is-visible {
  opacity: 1;
  transform: translateY(0);
}

@media (prefers-reduced-motion: reduce) {
  .pricing-card {
    opacity: 1;
    transform: none;
    transition: border-color 0.18s;
  }
}

.pricing-card--featured {
  border-color: var(--troly-action);
  border-width: 1.5px;
  box-shadow: 0 0 0 1px var(--troly-action), 0 18px 48px rgba(0, 0, 0, 0.22);
}

@media (min-width: 900px) {
  .pricing-card--featured { padding: 40px 30px; }
}

/* "Más popular" badge — flows in-card (no position:fixed) */
.pricing-card__badge {
  align-self: flex-start;
  display: inline-block;
  background: var(--troly-action);
  color: var(--troly-action-ink);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 5px 12px;
  border-radius: var(--troly-radius-pill);
  margin-bottom: 16px;
}

/* "Tu plan actual" — insignia informativa en brass (acento, nunca acción) */
.pricing-card__badge--current {
  background: transparent;
  color: var(--troly-accent);
  border: 1px solid var(--troly-accent);
}

.pricing-card__name {
  font-family: var(--troly-font-display);
  font-weight: 500;
  font-size: 1.6rem;
  line-height: 1.1;
  color: var(--troly-fg);
  margin-bottom: 6px;
}

.pricing-card__tagline {
  font-size: 0.9rem;
  line-height: 1.4;
  color: var(--troly-fg-muted);
  margin-bottom: 22px;
}

/* ── Price block ─────────────────────────────────────────────── */
.pricing-card__price {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 6px;
  padding-bottom: 22px;
  margin-bottom: 22px;
  border-bottom: 1px solid var(--troly-border);
}

.pricing-card__amount {
  font-family: var(--troly-font-display);
  font-weight: 700;
  font-size: 2.4rem;
  line-height: 1;
  color: var(--troly-fg);
}

.pricing-card__period {
  font-size: 0.95rem;
  color: var(--troly-fg-muted);
}

.pricing-card__permonth {
  flex-basis: 100%;
  font-family: var(--troly-font-mono);
  font-size: 0.8rem;
  color: var(--troly-fg-subtle);
  margin-top: 6px;
}

/* Pro — free forever (fuente grande + apostilla pequeña) */
.pricing-card__free {
  font-family: var(--troly-font-display);
  font-weight: 700;
  font-size: 2.4rem;
  line-height: 1;
  color: var(--troly-fg);
}

.pricing-card__free-forever {
  font-size: 0.85rem;
  color: var(--troly-fg-muted);
}

/* Seller — description block instead of a raw price */
.pricing-card__price--custom { flex-direction: column; align-items: flex-start; }

.pricing-card__custom {
  font-family: var(--troly-font-display);
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1.1;
  color: var(--troly-fg);
}

.pricing-card__desc {
  font-size: 0.88rem;
  line-height: 1.5;
  color: var(--troly-fg-muted);
  margin-top: 12px;
}

/* ── Features ────────────────────────────────────────────────── */
.pricing-card__features {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1 1; /* push footer to the bottom for equal-height cards */
  margin: 0 0 26px;
}

.pricing-card__feature {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 0.9rem;
  line-height: 1.4;
  color: var(--troly-fg);
}

.pricing-card__check {
  flex-shrink: 0;
  margin-top: 1px;
  color: var(--troly-action);
}

/* ── Footer / CTA ────────────────────────────────────────────── */
.pricing-card__foot {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: auto;
}

.pricing-card__cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 13px 20px;
  border-radius: var(--troly-radius-md);
  font-family: var(--troly-font-body);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.005em;
  transition: opacity 0.18s, transform 0.12s, background 0.18s, border-color 0.18s;
  cursor: pointer;
}

/* El CTA de Premium es <button> cuando hay sesión (dispara Stripe Checkout). */
.pricing-card__cta:disabled {
  opacity: 0.6;
  cursor: wait;
  transform: none;
}

.pricing-card__cta:hover { transform: translateY(-1px); }
.pricing-card__cta:active { transform: translateY(0); }

.pricing-card__cta--primary {
  background: var(--troly-action);
  color: var(--troly-action-ink);
  border: 1px solid var(--troly-action);
}
.pricing-card__cta--primary:hover { opacity: 0.88; }

.pricing-card__cta--ghost {
  background: transparent;
  color: var(--troly-fg);
  border: 1px solid var(--troly-border-strong);
}
.pricing-card__cta--ghost:hover { border-color: var(--troly-action); }

.pricing-card__cta:focus-visible {
  outline: 2px solid var(--troly-action);
  outline-offset: 2px;
}

.pricing-card__note {
  text-align: center;
  font-size: 0.78rem;
  color: var(--troly-fg-subtle);
}

/* Mismo rojo que .error-banner (index.css). */
.pricing-card__note--error { color: #f85149; }
`, "",{"version":3,"sources":["webpack://./src/pages/Pricing.css"],"names":[],"mappings":"AAAA;;;;kEAIkE;;AAElE;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB,EAAE,kDAAkD;EACtE,2BAA2B;EAC3B,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6DAA6D;EAC7D,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA,mEAAmE;AACnE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,qCAAqC;EACrC,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,mEAAmE;AACnE;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,0BAA0B,EAAE,mCAAmC;EAC/D,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;IACT,mBAAmB,EAAE,gDAAgD;EACvE;AACF;;AAEA,mEAAmE;AACnE;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,qCAAqC;EACrC,qCAAqC;EACrC,kBAAkB;EAClB,qEAAqE;EACrE,UAAU;EACV,2BAA2B;EAC3B,sEAAsE;AACxE;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE;IACE,UAAU;IACV,eAAe;IACf,8BAA8B;EAChC;AACF;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,0EAA0E;AAC5E;;AAEA;EACE,0BAA0B,kBAAkB,EAAE;AAChD;;AAEA,4DAA4D;AAC5D;EACE,sBAAsB;EACtB,qBAAqB;EACrB,+BAA+B;EAC/B,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,4EAA4E;AAC5E;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA,2DAA2D;AAC3D;EACE,sCAAsC;EACtC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,sDAAsD;AACtD,+BAA+B,sBAAsB,EAAE,uBAAuB,EAAE;;AAEhF;EACE,sCAAsC;EACtC,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO,EAAE,qDAAqD;EAC9D,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gFAAgF;EAChF,eAAe;AACjB;;AAEA,+EAA+E;AAC/E;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA,2BAA2B,2BAA2B,EAAE;AACxD,4BAA4B,wBAAwB,EAAE;;AAEtD;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,qCAAqC;AACvC;AACA,oCAAoC,aAAa,EAAE;;AAEnD;EACE,uBAAuB;EACvB,sBAAsB;EACtB,4CAA4C;AAC9C;AACA,kCAAkC,iCAAiC,EAAE;;AAErE;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA,8CAA8C;AAC9C,6BAA6B,cAAc,EAAE","sourcesContent":["/* ─────────────────────────────────────────────────────────────\n   Troly · /precios — full-screen pricing slide\n   Tokens-only (Troly · Onyx Club). Fully theme-aware via\n   --troly-* variables. No hardcoded hex, no position:fixed.\n   ───────────────────────────────────────────────────────────── */\n\n.pricing {\n  position: relative;\n  min-height: 100vh;\n  min-height: 100svh; /* honors mobile browser chrome / PWA standalone */\n  background: var(--troly-bg);\n  color: var(--troly-fg);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: clamp(72px, 12vh, 120px) 20px clamp(40px, 8vh, 80px);\n  font-family: var(--troly-font-body);\n  overflow-x: hidden;\n}\n\n/* ── Header ──────────────────────────────────────────────────── */\n.pricing__head {\n  text-align: center;\n  max-width: 640px;\n  margin-bottom: clamp(36px, 6vh, 64px);\n}\n\n.pricing__eyebrow {\n  display: inline-block;\n  font-family: var(--troly-font-mono);\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: var(--troly-accent);\n  margin-bottom: 14px;\n}\n\n.pricing__title {\n  font-family: var(--troly-font-display);\n  font-weight: 500;\n  font-size: clamp(2.2rem, 7vw, 3.4rem);\n  line-height: 1.05;\n  letter-spacing: -0.01em;\n  color: var(--troly-fg);\n  margin-bottom: 14px;\n}\n\n.pricing__subtitle {\n  font-size: clamp(0.95rem, 3.5vw, 1.1rem);\n  line-height: 1.5;\n  color: var(--troly-fg-muted);\n}\n\n/* ── Grid ────────────────────────────────────────────────────── */\n.pricing__grid {\n  width: 100%;\n  max-width: 1100px;\n  display: grid;\n  grid-template-columns: 1fr; /* mobile portrait: single column */\n  gap: 20px;\n  align-items: stretch;\n}\n\n@media (min-width: 900px) {\n  .pricing__grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 24px;\n    align-items: center; /* lets the featured card stand a touch taller */\n  }\n}\n\n/* ── Card ────────────────────────────────────────────────────── */\n.pricing-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  background: var(--troly-bg-elevated);\n  border: 1px solid var(--troly-border);\n  border-radius: var(--troly-radius-lg);\n  padding: 32px 26px;\n  /* entrance state — revealed via .is-visible (IntersectionObserver) */\n  opacity: 0;\n  transform: translateY(16px);\n  transition: opacity 0.3s ease, transform 0.3s ease, border-color 0.18s;\n}\n\n.pricing-card.is-visible {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .pricing-card {\n    opacity: 1;\n    transform: none;\n    transition: border-color 0.18s;\n  }\n}\n\n.pricing-card--featured {\n  border-color: var(--troly-action);\n  border-width: 1.5px;\n  box-shadow: 0 0 0 1px var(--troly-action), 0 18px 48px rgba(0, 0, 0, 0.22);\n}\n\n@media (min-width: 900px) {\n  .pricing-card--featured { padding: 40px 30px; }\n}\n\n/* \"Más popular\" badge — flows in-card (no position:fixed) */\n.pricing-card__badge {\n  align-self: flex-start;\n  display: inline-block;\n  background: var(--troly-action);\n  color: var(--troly-action-ink);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  padding: 5px 12px;\n  border-radius: var(--troly-radius-pill);\n  margin-bottom: 16px;\n}\n\n/* \"Tu plan actual\" — insignia informativa en brass (acento, nunca acción) */\n.pricing-card__badge--current {\n  background: transparent;\n  color: var(--troly-accent);\n  border: 1px solid var(--troly-accent);\n}\n\n.pricing-card__name {\n  font-family: var(--troly-font-display);\n  font-weight: 500;\n  font-size: 1.6rem;\n  line-height: 1.1;\n  color: var(--troly-fg);\n  margin-bottom: 6px;\n}\n\n.pricing-card__tagline {\n  font-size: 0.9rem;\n  line-height: 1.4;\n  color: var(--troly-fg-muted);\n  margin-bottom: 22px;\n}\n\n/* ── Price block ─────────────────────────────────────────────── */\n.pricing-card__price {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 6px;\n  padding-bottom: 22px;\n  margin-bottom: 22px;\n  border-bottom: 1px solid var(--troly-border);\n}\n\n.pricing-card__amount {\n  font-family: var(--troly-font-display);\n  font-weight: 700;\n  font-size: 2.4rem;\n  line-height: 1;\n  color: var(--troly-fg);\n}\n\n.pricing-card__period {\n  font-size: 0.95rem;\n  color: var(--troly-fg-muted);\n}\n\n.pricing-card__permonth {\n  flex-basis: 100%;\n  font-family: var(--troly-font-mono);\n  font-size: 0.8rem;\n  color: var(--troly-fg-subtle);\n  margin-top: 6px;\n}\n\n/* Pro — free forever (fuente grande + apostilla pequeña) */\n.pricing-card__free {\n  font-family: var(--troly-font-display);\n  font-weight: 700;\n  font-size: 2.4rem;\n  line-height: 1;\n  color: var(--troly-fg);\n}\n\n.pricing-card__free-forever {\n  font-size: 0.85rem;\n  color: var(--troly-fg-muted);\n}\n\n/* Seller — description block instead of a raw price */\n.pricing-card__price--custom { flex-direction: column; align-items: flex-start; }\n\n.pricing-card__custom {\n  font-family: var(--troly-font-display);\n  font-weight: 500;\n  font-size: 1.5rem;\n  line-height: 1.1;\n  color: var(--troly-fg);\n}\n\n.pricing-card__desc {\n  font-size: 0.88rem;\n  line-height: 1.5;\n  color: var(--troly-fg-muted);\n  margin-top: 12px;\n}\n\n/* ── Features ────────────────────────────────────────────────── */\n.pricing-card__features {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  flex: 1; /* push footer to the bottom for equal-height cards */\n  margin: 0 0 26px;\n}\n\n.pricing-card__feature {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  font-size: 0.9rem;\n  line-height: 1.4;\n  color: var(--troly-fg);\n}\n\n.pricing-card__check {\n  flex-shrink: 0;\n  margin-top: 1px;\n  color: var(--troly-action);\n}\n\n/* ── Footer / CTA ────────────────────────────────────────────── */\n.pricing-card__foot {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: auto;\n}\n\n.pricing-card__cta {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 13px 20px;\n  border-radius: var(--troly-radius-md);\n  font-family: var(--troly-font-body);\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: -0.005em;\n  transition: opacity 0.18s, transform 0.12s, background 0.18s, border-color 0.18s;\n  cursor: pointer;\n}\n\n/* El CTA de Premium es <button> cuando hay sesión (dispara Stripe Checkout). */\n.pricing-card__cta:disabled {\n  opacity: 0.6;\n  cursor: wait;\n  transform: none;\n}\n\n.pricing-card__cta:hover { transform: translateY(-1px); }\n.pricing-card__cta:active { transform: translateY(0); }\n\n.pricing-card__cta--primary {\n  background: var(--troly-action);\n  color: var(--troly-action-ink);\n  border: 1px solid var(--troly-action);\n}\n.pricing-card__cta--primary:hover { opacity: 0.88; }\n\n.pricing-card__cta--ghost {\n  background: transparent;\n  color: var(--troly-fg);\n  border: 1px solid var(--troly-border-strong);\n}\n.pricing-card__cta--ghost:hover { border-color: var(--troly-action); }\n\n.pricing-card__cta:focus-visible {\n  outline: 2px solid var(--troly-action);\n  outline-offset: 2px;\n}\n\n.pricing-card__note {\n  text-align: center;\n  font-size: 0.78rem;\n  color: var(--troly-fg-subtle);\n}\n\n/* Mismo rojo que .error-banner (index.css). */\n.pricing-card__note--error { color: #f85149; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
